import React, { useMemo } from 'react';
import { useLocation } from 'react-router';
import { Link, matchPath } from 'react-router-dom';

import logoDarkSvg from 'assets/logo_dark.svg';
import logoLightSvg from 'assets/logo_light.svg';

import { homeUrl } from '@urls';

export const Logo: React.FC<{ light?: boolean }> = ({ light }) => {
  const { pathname } = useLocation();
  const logoSrc = light ? logoLightSvg : logoDarkSvg;
  // Intrinsic dimensions from SVG viewBox to prevent CLS (logo_light/logo_dark: 181×30)
  const width = 181;
  const height = 30;

  return (
    <Link to={homeUrl} className="logo align-middle">
      <img
        src={logoSrc}
        alt="Praca na Kołach"
        width={width}
        height={height}
        style={{ height: 'auto' }}
      />
    </Link>
  );
};
